import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 12a4 4 0 1 0 8 0a4 4 0 1 0 -8 0","key":"svg-0"}],["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-1"}],["path",{"d":"M15 15l3.35 3.35","key":"svg-2"}],["path",{"d":"M9 15l-3.35 3.35","key":"svg-3"}],["path",{"d":"M5.65 5.65l3.35 3.35","key":"svg-4"}],["path",{"d":"M18.35 5.65l-3.35 3.35","key":"svg-5"}]]

const IconLifebuoy = createReactComponent('outline', 'lifebuoy', 'Lifebuoy', __iconNode);

export default IconLifebuoy;